export default __webpack_public_path__ + "static/webRotator/svg/9827c3c6f37a9273c5fe776bfeb9e5ea.svg";